<template>
  <el-dialog :title="dialogType==0?'添加公告':'编辑公告'" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" label-width="80px">
        <el-form-item label="内容">
          <el-input v-model="content" placeholder="请输入栏目名称" type="textarea"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="savePrograma" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from '@/api.js'

  export default {
    name: "addColumnDialog",
    props: ["visible", "dialogType", "dialogContent"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        content:''
      };
    },
    watch: {
      visible () {
        this.dialogVisible = this.visible
        if (this.dialogType === 1) {
          this.content = this.dialogContent.content
        }
      }
    },
    created() {
    },
    methods: {
      savePrograma() {
        if (this.content === '') {
          this.$message({
            message: '请编辑需要添加的内容',
            type: 'warning'
          });
          return
        }
        let url_ = api.shopconf_notice_add;
        let data_ = {}
        data_.content = this.content
        if (this.dialogType === 1) {
          url_ = api.shopconf_notice_edit;
          data_.id = this.dialogContent.id;
        }
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                let title = '添加成功!'
                if (this.dialogType === 1) {
                  title = '编辑成功!'
                }
                this.$message({
                  message: title
                });
                this.dialogVisible = false
                this.content = ''
                this.$emit('loadInitFn');
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>

